import React from 'react'
import './TableView.scss'

export const TableView = () => (
  <div>
    <div className='table-plan-list ing-instalment-plan-list' role='grid' aria-readonly='true'>
      <div role='rowgroup' className='uia-plan-history-table-header planHistoryHead mobile-xs-hidden'>
        <div role='row' aria-readonly='true' className='thead'>
          <div role='columnheader' className='td uia-thead-collapse'>
            <span className='sr-only'>Show additional information</span>
          </div>
          <div role='columnheader' className='td date uia-thead-date-created'>
            <span>Date created</span>
          </div>
          <div role='columnheader' className='td uia-thead-plan-name'>
            <span>Name</span>
          </div>
          <div role='columnheader' className='td uia-thead-payments-remaining text-right'>
            <span>Repayments remaining</span>
          </div>
          <div role='columnheader' className='td uia-thead-next-repayment text-right'>
            <span>Next repayment</span>
          </div>
          <div role='columnheader' className='td uia-thead-amount-interm text-right'>
            <span>Balance remaining</span>
          </div>
          <div role='columnheader' className='uia-thead-collapse uia-thead-instalment-options'>
            <span className='sr-only'>Instalment options</span>
          </div>
          <div role='columnheader' className='uia-thead-collapse uia-thead-information'>
            <span className='sr-only'>Additional information</span>
          </div>
        </div>
      </div>
      <div role='rowgroup' className='mobile-only'>
        <div role='row' className='mobile-transaction-header'>
          <div role='gridcell' className='td padding-10-15'>22 Sep 2016</div>
        </div>
      </div>
      <div role='rowgroup' className='plan-list-data'>
        <div role='row' className='cell-header'>
          <div role='gridcell' className='expandButtonGrid mobile-xs-hidden'>
            <div className='sr-only'>
              <button className='expandCollapseButton' aria-expanded='false'
                aria-label='Show additional information for Entertainment instalment plan'
                id='expandCollapseButton_0_0' />
            </div>
          </div>
          <div role='gridcell' className='td date uia-date-created-val text-align-left mobile-xs-hidden'>
            <div className='row-icon-group'>
              <span className='open-text'>
                <span aria-hidden='true' className='icon-font icon-space right row-icon icon-arrow-down' />
              </span>
            </div>
            <span className='uia-date-created-val'>22 Sep 2016</span>
          </div>
          <div role='gridcell' className='td td-left uia-plan-name-val'>Entertainment</div>
          <div role='gridcell' className='td mobile-xs-hidden text-right uia-payments-remaining-val'>3</div>
          <div role='gridcell' className='td text-green text-right mobile-xs-hidden uia-next-repayment-val'>$51.99</div>
          <div role='gridcell' className='td text-right text-red uia-amount-section uia-amount-intermval'>
            <span>-</span>$500.20
        </div>
          <div role='gridcell' className='instalment-option-cell td text-align-left noPadLeft mobile-xs-hidden'>
            <span className='uia-plan-actions mobile-xs-hidden'>
              <select id='planActionDropdown_0_0'>
                <option>button 1</option>
                <option>button 2</option>
              </select>
            </span>
            <span className='sr-only' hidden>There are no available instalment options.</span>
          </div>
          <div role='gridcell' className='sr-only-noclip'>
            <div className='sr-only'>
              <div className='uia-extended-view-sr sr-only'>
              Repayment start date: 21 April 2016,
              Term: 10 months,
              End date: 7 February 2017,
              Edits remaining: 3,
              Total interest charges: $50.00,
              Total to be repaid: $300.00
            </div>
            </div>
            <span
              className='sr-only'>Additional information is collapsed, expand by pressing button in first column.</span>
            <div className='cell-content extendedViewCollapsable' aria-hidden='true'>
              <iron-collapse aria-hidden='true' id='extendedView_0_0' role='presentation' className='iron-collapse-closed' aria-expanded='false'>
                <ing-instalment-extended-view>
                  <div className='uia-extended-view extended-tablet-view mobile-xs-hidden' aria-hidden='true'>Some
                  content
                </div>
                  <div className='uia-extended-view extended-mobile-view mobile-xs-hidden' aria-hidden='true'>Some
                  content
                </div>
                </ing-instalment-extended-view>
              </iron-collapse>
            </div>
          </div>
        </div>
      </div>
      <div role='rowgroup' className='plan-list-data'>
        <div role='row' className='cell-header'>
          <div role='gridcell' className='expandButtonGrid mobile-xs-hidden'>
            <div className='sr-only'>
              <button className='expandCollapseButton' aria-expanded='false'
                aria-label='Show additional information for Entertainment instalment plan'
                id='expandCollapseButton_0_0' />
            </div>
          </div>
          <div role='gridcell' className='td date uia-date-created-val text-align-left mobile-xs-hidden'>
            <div className='row-icon-group'>
              <span className='open-text'>
                <span className='icon-font icon-space right row-icon icon-arrow-down' aria-hidden='true' />
              </span>
            </div>
            <span className='uia-date-created-val'>22 Sep 2016</span>
          </div>
          <div role='gridcell' className='td td-left uia-plan-name-val'>group by date</div>
          <div role='gridcell' className='td mobile-xs-hidden text-right uia-payments-remaining-val'>9</div>
          <div role='gridcell' className='td text-green text-right mobile-xs-hidden uia-next-repayment-val'>$29.37</div>
          <div role='gridcell' className='td text-right text-red uia-amount-section uia-amount-intermval'>
            <span>-</span>$250.00
        </div>
          <div role='gridcell' className='instalment-option-cell td text-align-left noPadLeft mobile-xs-hidden'>
            <span className='uia-plan-actions mobile-xs-hidden'>
              <select id='planActionDropdown_0_0'>
                <option>button 1</option>
                <option>button 2</option>
              </select>
            </span>
            <span className='sr-only' hidden>There are no available instalment options.</span>
          </div>
          <div role='gridcell' className='sr-only-noclip'>
            <div className='sr-only'>
              <div className='uia-extended-view-sr sr-only'>
              Repayment start date: 21 April 2016,
              Term: 10 months,
              End date: 7 February 2017,
              Edits remaining: 3,
              Total interest charges: $50.00,
              Total to be repaid: $300.00
            </div>
            </div>
            <span
              className='sr-only'>Additional information is collapsed, expand by pressing button in first column.</span>
            <div className='cell-content extendedViewCollapsable' aria-hidden='true'>
              <iron-collapse aria-hidden='true' id='extendedView_1_0' role='presentation' className='iron-collapse-closed'
                aria-expanded='false'>
                <ing-instalment-extended-view>
                  <div className='uia-extended-view extended-tablet-view mobile-xs-hidden' aria-hidden='true'>Some
                  content
                </div>
                  <div className='uia-extended-view extended-mobile-view mobile-xs-hidden' aria-hidden='true'>Some
                  content
                </div>
                </ing-instalment-extended-view>
              </iron-collapse>
            </div>
          </div>
        </div>
      </div>

      <div role='rowgroup' className='mobile-only'>
        <div role='row' className='mobile-transaction-header'>
          <div role='gridcell' className='td padding-10-15'>08 Sep 2016</div>
        </div>
      </div>
      <div role='rowgroup' className='plan-list-data'>
        <div role='row' className='cell-header'>
          <div role='gridcell' className='expandButtonGrid mobile-xs-hidden'>
            <div className='sr-only'>
              <button className='expandCollapseButton' aria-expanded='false'
                aria-label='Show additional information for Entertainment instalment plan'
                id='expandCollapseButton_1_0' />
            </div>
          </div>
          <div role='gridcell' className='td date uia-date-created-val text-align-left mobile-xs-hidden'>
            <div className='row-icon-group'>
              <span className='open-text'>
                <span className='icon-font icon-space right row-icon icon-arrow-down' aria-hidden='true' />
              </span>
            </div>
            <span className='uia-date-created-val'>08 Sep 2016</span>
          </div>
          <div role='gridcell' className='td td-left uia-plan-name-val'>Bills</div>
          <div role='gridcell' className='td mobile-xs-hidden text-right uia-payments-remaining-val'>0</div>
          <div role='gridcell' className='td text-green text-right mobile-xs-hidden uia-next-repayment-val'>$0.00</div>
          <div role='gridcell' className='td text-right text-red uia-amount-section uia-amount-intermval'>
            <span>-</span>$1000.00
        </div>
          <div role='gridcell' className='instalment-option-cell td text-align-left noPadLeft mobile-xs-hidden'>
            <span className='uia-plan-actions mobile-xs-hidden'>
              <select id='planActionDropdown_0_0'>
                <option>button 1</option>
                <option>button 2</option>
              </select>
            </span>
            <span className='sr-only' hidden>There are no available instalment options.</span>
          </div>
          <div role='gridcell' className='sr-only-noclip'>
            <div className='sr-only'>
              <div className='uia-extended-view-sr sr-only'>
              Repayment start date: 21 April 2016,
              Term: 10 months,
              End date: 7 February 2017,
              Edits remaining: 3,
              Total interest charges: $50.00,
              Total to be repaid: $300.00
            </div>
            </div>
            <span
              className='sr-only'>Additional information is collapsed, expand by pressing button in first column.</span>
            <div className='cell-content extendedViewCollapsable' aria-hidden='true'>
              <iron-collapse aria-hidden='true' id='extendedView_1_0' role='presentation' className='iron-collapse-closed'
                aria-expanded='false'>
                <ing-instalment-extended-view>
                  <div className='uia-extended-view extended-tablet-view mobile-xs-hidden' aria-hidden='true'>Some
                  content
                </div>
                  <div className='uia-extended-view extended-mobile-view mobile-xs-hidden' aria-hidden='true'>Some
                  content
                </div>
                </ing-instalment-extended-view>
              </iron-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default TableView



// WEBPACK FOOTER //
// ./src/routes/Table/components/TableView.js